(function() {
  var DEFAULT_ENDPOINT = 'https://storefront.abokpower.com/api/v1/actions/report';
  var DEFAULT_THRESHOLD = 0.8;
  var DEFAULT_EXPOSURE_DURATION = 2000;
  var DEFAULT_QUEUE_FLUSH_INTERVAL = 3000;
  var DEFAULT_QUEUE_MAX_ACTIONS = 20;
  var DEFAULT_QUEUE_MAX_BYTES = 48 * 1024;
  var DEFAULT_QUEUE_RETRY_DELAYS = [1000, 3000];
  var IMMEDIATE_ACTION_TYPES = [
    'click_addtocart',
    'click_checkout',
    'click_plus',
    'click_minus',
    'click_remove',
    'view'
  ];
  var DEVICE_ID_STORAGE_KEY = 'abok_expose_device_id';
  var ATTRIBUTION_DOMAIN_STORAGE_KEY = 'abok_expose_attribution_domain';
  var ATTRIBUTION_DOMAIN_TIMESTAMP_STORAGE_KEY = 'abok_expose_attribution_domain_ts';
  var ATTRIBUTION_DOMAIN_MAX_AGE = 24 * 60 * 60 * 1000;
  var HOME_DOMAIN = 'home';
  var BANNER_DOMAIN = 'banner';
  var NAV_DOMAIN = 'nav';
  var FOOTER_DOMAIN = 'footer';
  var PRODUCT_SHOWCASE_DOMAIN = 'product showcase';
  var USAGE_SCENARIOS_DOMAIN = 'usage scenarios';
  var CPAP_DOMAIN = 'cpap';
  var EXTRAL_DOMAIN = 'extral';

  // Normalize selector, single element, NodeList, HTMLCollection, or array to an element array.
  function isElement(target) {
    return target && target.nodeType === Node.ELEMENT_NODE;
  }

  function resolveElements(target) {
    if (typeof target === 'string') {
      return Array.prototype.slice.call(document.querySelectorAll(target));
    }

    if (isElement(target)) {
      return [target];
    }

    if (target instanceof NodeList || target instanceof HTMLCollection || Array.isArray(target)) {
      return Array.prototype.filter.call(target, isElement);
    }

    return [];
  }

  function getRandomId() {
    if (window.crypto && typeof window.crypto.randomUUID === 'function') {
      return window.crypto.randomUUID();
    }

    return 'device-' + Date.now().toString(36) + '-' + Math.random().toString(36).slice(2);
  }

  // Device id is persisted in localStorage; if storage is unavailable, use a temporary id.
  function getDeviceId() {
    try {
      var savedDeviceId = window.localStorage.getItem(DEVICE_ID_STORAGE_KEY);

      if (savedDeviceId) {
        return savedDeviceId;
      }

      var deviceId = getRandomId();
      window.localStorage.setItem(DEVICE_ID_STORAGE_KEY, deviceId);
      return deviceId;
    }
    catch (error) {
      return getRandomId();
    }
  }

  function getMetaContent(name) {
    var meta = document.querySelector('meta[name="' + name + '"]');
    return meta ? meta.getAttribute('content') || '' : '';
  }

  function getUrlSource() {
    try {
      return new URLSearchParams(window.location.search).get('source') || '';
    }
    catch (error) {
      var match = window.location.search.match(/[?&]source=([^&]*)/);
      return match ? decodeURIComponent(match[1].replace(/\+/g, ' ')) : '';
    }
  }

  function normalizeValue(value) {
    return String(value || '').trim().toLowerCase();
  }

  function isUsageScenariosValue(value) {
    var normalized = normalizeValue(value).replace(/_/g, '-');

    return normalized === USAGE_SCENARIOS_DOMAIN ||
      normalized === 'usage' ||
      normalized === 'usage-scenarios' ||
      normalized === 'home-usage' ||
      normalized === 'home usage' ||
      normalized === 'usagescenarios';
  }

  function isNavValue(value) {
    var normalized = normalizeValue(value).replace(/_/g, '-');

    return normalized === NAV_DOMAIN ||
      normalized === 'header-nav' ||
      normalized === 'header nav' ||
      normalized === 'header-nav-drawer' ||
      normalized === 'header nav drawer';
  }

  function normalizeReportDomain(domain) {
    var normalized = normalizeValue(domain);

    if (normalized === HOME_DOMAIN) {
      return HOME_DOMAIN;
    }

    if (normalized === BANNER_DOMAIN) {
      return BANNER_DOMAIN;
    }

    if (isNavValue(normalized)) {
      return NAV_DOMAIN;
    }

    if (normalized === FOOTER_DOMAIN) {
      return FOOTER_DOMAIN;
    }

    if (normalized === PRODUCT_SHOWCASE_DOMAIN) {
      return PRODUCT_SHOWCASE_DOMAIN;
    }

    if (isUsageScenariosValue(normalized)) {
      return USAGE_SCENARIOS_DOMAIN;
    }

    if (normalized === CPAP_DOMAIN) {
      return CPAP_DOMAIN;
    }

    return EXTRAL_DOMAIN;
  }

  function getSourceDomain(source) {
    var normalized = normalizeValue(source);

    if (!normalized) {
      return '';
    }

    return normalizeReportDomain(normalized);
  }

  function syncProductLinkSources(root) {
    var selector = '[data-product-link-source]';
    var scopes = Array.prototype.slice.call(root.querySelectorAll(selector));
    if (root.matches?.(selector)) scopes.unshift(root);

    scopes.forEach(function(scope) {
      var source = getSourceDomain(scope.dataset.productLinkSource);
      if (!source || source === EXTRAL_DOMAIN) return;

      scope.querySelectorAll('a[href]').forEach(function(link) {
        try {
          var href = link.getAttribute('href').trim();
          if (!href || href.charAt(0) === '#' || link.hasAttribute('download')) return;

          var destination = new URL(href, window.location.href);
          if (!['http:', 'https:'].includes(destination.protocol) ||
            !/\/products\/[^/]+\/?$/.test(destination.pathname)) return;

          destination.searchParams.set('source', source);
          link.href = destination.href;
        }
        catch (error) {
          // 无效链接保留原值，不中断页面和其他入口的归因。
        }
      });
    });
  }

  function getStoredAttributionDomain() {
    try {
      var sessionDomain = window.sessionStorage.getItem(ATTRIBUTION_DOMAIN_STORAGE_KEY);

      if (sessionDomain) {
        return sessionDomain;
      }

      var storedAt = Number(window.localStorage.getItem(ATTRIBUTION_DOMAIN_TIMESTAMP_STORAGE_KEY));
      var localDomain = window.localStorage.getItem(ATTRIBUTION_DOMAIN_STORAGE_KEY);

      if (localDomain && storedAt && Date.now() - storedAt <= ATTRIBUTION_DOMAIN_MAX_AGE) {
        return localDomain;
      }

      return '';
    }
    catch (error) {
      return '';
    }
  }

  function clearStoredAttributionDomain() {
    try {
      window.sessionStorage.removeItem(ATTRIBUTION_DOMAIN_STORAGE_KEY);
      window.sessionStorage.removeItem(ATTRIBUTION_DOMAIN_TIMESTAMP_STORAGE_KEY);
      window.localStorage.removeItem(ATTRIBUTION_DOMAIN_STORAGE_KEY);
      window.localStorage.removeItem(ATTRIBUTION_DOMAIN_TIMESTAMP_STORAGE_KEY);
    }
    catch (error) {}
  }

  function setStoredAttributionDomain(domain) {
    try {
      var normalizedDomain = normalizeReportDomain(domain);
      var savedAt = String(Date.now());

      window.sessionStorage.setItem(ATTRIBUTION_DOMAIN_STORAGE_KEY, normalizedDomain);
      window.sessionStorage.setItem(ATTRIBUTION_DOMAIN_TIMESTAMP_STORAGE_KEY, savedAt);
      window.localStorage.setItem(ATTRIBUTION_DOMAIN_STORAGE_KEY, normalizedDomain);
      window.localStorage.setItem(ATTRIBUTION_DOMAIN_TIMESTAMP_STORAGE_KEY, savedAt);
    }
    catch (error) {}
  }

  function isHomePage() {
    if (document.body && document.body.classList.contains('template-index')) {
      return true;
    }

    return window.location.pathname.replace(/\/+$/, '') === '';
  }

  function isSameOriginReferrer() {
    if (!document.referrer) {
      return false;
    }

    try {
      return new URL(document.referrer).origin === window.location.origin;
    }
    catch (error) {
      return false;
    }
  }

  function isReferrerHomePage() {
    if (!document.referrer) {
      return false;
    }

    try {
      var referrerUrl = new URL(document.referrer);

      return referrerUrl.origin === window.location.origin &&
        referrerUrl.pathname.replace(/\/+$/, '') === '';
    }
    catch (error) {
      return false;
    }
  }

  function syncAttributionDomainFromUrl() {
    if (isHomePage()) {
      clearStoredAttributionDomain();
      return;
    }

    var sourceDomain = getSourceDomain(getUrlSource());

    if (!sourceDomain) {
      if (!isSameOriginReferrer()) {
        clearStoredAttributionDomain();
      }

      return;
    }

    if (sourceDomain !== EXTRAL_DOMAIN ||
      !getStoredAttributionDomain() ||
      isReferrerHomePage() ||
      !isSameOriginReferrer()) {
      setStoredAttributionDomain(sourceDomain);
    }
  }

  function getAttributionDomain(domain, element) {
    var explicitDomain = normalizeValue(domain || element?.dataset?.domain);

    if (explicitDomain === FOOTER_DOMAIN) {
      return FOOTER_DOMAIN;
    }

    if (isHomePage()) {
      return HOME_DOMAIN;
    }

    return getStoredAttributionDomain() ||
      getSourceDomain(getUrlSource()) ||
      EXTRAL_DOMAIN;
  }

  function getClickAttributionDomain(element) {
    var entryDomain = element?.dataset?.domain;

    if (entryDomain) {
      return normalizeReportDomain(entryDomain);
    }

    if (!isHomePage()) {
      return getAttributionDomain('', element);
    }

    return normalizeReportDomain(getUrlSource());
  }

  function persistClickDomain(element) {
    setStoredAttributionDomain(getClickAttributionDomain(element));
  }

  // Login email is injected by theme.liquid. Anonymous users leave this empty.
  function getUserEmail(config) {
    config = config || {};

    return config.userEmail ||
      config.email ||
      window.EXPOSE_USER_EMAIL ||
      getMetaContent('customer-email') ||
      '';
  }

  // user_id = device_id_user_email; anonymous users send device_id only.
  function getUserId(config) {
    config = config || {};

    if (config.userId) return config.userId;

    return getDeviceId();
    // return [
    //   getDeviceId(),
    //   getUserEmail(config)
    // ].filter(Boolean).join('_');
  }

  function bufferToHex(buffer) {
    return Array.prototype.map.call(new Uint8Array(buffer), function(byte) {
      return byte.toString(16).padStart(2, '0');
    }).join('');
  }

  function fallbackHash(value) {
    var hash = 0;
    var text = String(value);

    for (var index = 0; index < text.length; index += 1) {
      hash = ((hash << 5) - hash) + text.charCodeAt(index);
      hash |= 0;
    }

    return Math.abs(hash).toString(16);
  }

  async function hashText(value) {
    if (window.crypto && window.crypto.subtle && window.TextEncoder) {
      var buffer = await window.crypto.subtle.digest('SHA-256', new TextEncoder().encode(String(value)));
      return bufferToHex(buffer);
    }

    return fallbackHash(value);
  }

  function mergeAttribution(action) {
    try {
      if (window.AbokAttribution && typeof window.AbokAttribution.mergeIntoAction === 'function') {
        return window.AbokAttribution.mergeIntoAction(action);
      }
    }
    catch (error) {}

    return Object.assign({}, action || {});
  }

  // action can be a plain object or a function that derives payload fields from the element.
  function resolveAction(action, element) {
    if (typeof action === 'function') {
      return action(element);
    }

    return action || {};
  }

  // Build final report payload. Exposure defaults to action_type=exposure; clicks override it.
  async function buildExposureAction(action, element, config) {
    var resolvedAction = await Promise.resolve(resolveAction(action, element));
    var payload = Object.assign({
      action_type: 'exposure',
    }, resolvedAction || {});

    payload.user_id = payload.user_id || getUserId(config);
    payload.email = payload.email || getUserEmail(config);
    payload.item_id = payload.item_id || element?.dataset?.itemId || element?.dataset?.productId || element?.id || '';
    payload.domain = getAttributionDomain(payload.domain, element);
    payload = mergeAttribution(payload);

    // trace_id = hash(user_id + item_id + action_type + domain).
    payload.trace_id = payload.trace_id || await hashText([
      payload.user_id,
      payload.item_id,
      payload.action_type,
      payload.domain
    ].join(''));

    return payload;
  }

  function getReportBody(actions) {
    return JSON.stringify({
      actions: Array.isArray(actions) ? actions : [actions]
    });
  }

  function getBodySize(body) {
    if (window.TextEncoder) {
      return new TextEncoder().encode(body).byteLength;
    }

    return new Blob([body]).size;
  }

  // Optional fallback for cross-origin endpoints without CORS.
  function isCrossOriginEndpoint(endpoint) {
    try {
      return new URL(endpoint, window.location.href).origin !== window.location.origin;
    }
    catch (error) {
      return false;
    }
  }

  function reportActionSilently(endpoint, body, config) {
    if (navigator.sendBeacon && config.useBeacon !== false) {
      var blob = new Blob([body], {
        type: 'text/plain;charset=UTF-8'
      });

      if (navigator.sendBeacon(endpoint, blob)) {
        return Promise.resolve({
          ok: true,
          beacon: true
        });
      }
    }

    return fetch(endpoint, {
      method: 'POST',
      mode: 'no-cors',
      keepalive: true,
      credentials: 'omit',
      headers: {
        'Content-Type': 'text/plain;charset=UTF-8'
      },
      body: body
    }).then(function() {
      return {
        ok: true,
        opaque: true
      };
    });
  }

  async function reportActions(actions, options) {
    var config = options || {};
    var endpoint = config.endpoint || window.EXPOSE_REPORT_ENDPOINT || DEFAULT_ENDPOINT;
    var normalizedActions = (Array.isArray(actions) ? actions : [actions]).map(function(action) {
      if (!action || typeof action !== 'object') return action;

      return Object.assign({}, mergeAttribution(action), {
        domain: getAttributionDomain(action.domain)
      });
    });

    var body = getReportBody(normalizedActions);

    if (config.useBeacon === true && navigator.sendBeacon) {
      var beaconBody = new Blob([body], {
        type: 'text/plain;charset=UTF-8'
      });

      if (navigator.sendBeacon(endpoint, beaconBody)) {
        return {
          ok: true,
          beacon: true,
          actionCount: normalizedActions.length
        };
      }
    }

    if ((config.noCors || window.EXPOSE_REPORT_NO_CORS) && isCrossOriginEndpoint(endpoint)) {
      return reportActionSilently(endpoint, body, config);
    }

    var response = await fetch(endpoint, {
      method: 'POST',
      credentials: config.credentials || 'same-origin',
      keepalive: config.keepalive === true,
      headers: Object.assign({
        'Content-Type': 'application/json'
      }, config.headers || {}),
      body: body
    });

    if (!response.ok) {
      throw new Error(await response.text());
    }

    return response.json();
  }

  var eventQueue = null;

  function reportAction(action, options) {
    var config = options || {};

    if (eventQueue && config.skipQueueFlush !== true) {
      return eventQueue.flushWith(action, config);
    }

    return reportActions([action], config);
  }

  function enqueueAction(action, options) {
    if (options?.immediate === true || IMMEDIATE_ACTION_TYPES.includes(action?.action_type)) {
      return reportAction(action, options);
    }

    if (!eventQueue) {
      return reportActions([action], options);
    }

    return eventQueue.enqueue(action, options);
  }

  class ExposeEventQueue {
    constructor(options) {
      var config = options || {};
      this.flushInterval = config.flushInterval || DEFAULT_QUEUE_FLUSH_INTERVAL;
      this.maxActions = config.maxActions || DEFAULT_QUEUE_MAX_ACTIONS;
      this.maxBytes = config.maxBytes || DEFAULT_QUEUE_MAX_BYTES;
      this.retryDelays = config.retryDelays || DEFAULT_QUEUE_RETRY_DELAYS;
      this.entries = [];
      this.handleVisibilityChange = this.handleVisibilityChange.bind(this);
      this.handlePageHide = this.handlePageHide.bind(this);
      this.handleOnline = this.handleOnline.bind(this);
    }

    start() {
      if (this.started) return this;

      this.started = true;
      document.addEventListener('visibilitychange', this.handleVisibilityChange);
      window.addEventListener('pagehide', this.handlePageHide);
      window.addEventListener('online', this.handleOnline);
      return this;
    }

    enqueue(action, options) {
      var config = options || {};
      var promise = new Promise((resolve, reject) => {
        this.entries.push({
          action: action,
          options: config,
          resolve: resolve,
          reject: reject
        });
      });

      if (this.entries.length >= this.maxActions || this.getQueuedBodySize() >= this.maxBytes) {
        void this.flush('capacity');
      }
      else {
        this.scheduleFlush();
      }

      return promise;
    }

    flushWith(action, options) {
      var config = Object.assign({}, options || {}, {
        keepalive: true
      });

      return new Promise((resolve, reject) => {
        this.entries.push({
          action: action,
          options: config,
          resolve: resolve,
          reject: reject
        });
        void this.flush('immediate');
      });
    }

    flush(reason, flushOptions) {
      if (!this.entries.length) return Promise.resolve([]);

      this.cancelScheduledFlush();
      var entries = this.entries.splice(0);
      var batches = this.createBatches(entries);
      var lifecycle = reason === 'visibilitychange' || reason === 'pagehide';
      var config = Object.assign({}, flushOptions || {}, lifecycle ? {
        keepalive: true,
        useBeacon: true
      } : {});

      return Promise.all(batches.map((batch) => {
        return this.sendBatch(batch, config, lifecycle ? [] : this.retryDelays.slice());
      }));
    }

    createBatches(entries) {
      var batches = [];
      var currentBatch = [];

      entries.forEach((entry) => {
        var candidate = currentBatch.concat(entry);
        var candidateBody = getReportBody(candidate.map(function(item) {
          return item.action;
        }));
        var transportChanged = currentBatch.length &&
          this.getTransportKey(currentBatch[0].options) !== this.getTransportKey(entry.options);

        if (
          currentBatch.length &&
          (transportChanged || candidate.length > this.maxActions || getBodySize(candidateBody) > this.maxBytes)
        ) {
          batches.push(currentBatch);
          currentBatch = [entry];
          return;
        }

        currentBatch = candidate;
      });

      if (currentBatch.length) batches.push(currentBatch);
      return batches;
    }

    getTransportKey(options) {
      var config = options || {};
      return JSON.stringify({
        endpoint: config.endpoint || window.EXPOSE_REPORT_ENDPOINT || DEFAULT_ENDPOINT,
        noCors: Boolean(config.noCors || window.EXPOSE_REPORT_NO_CORS),
        credentials: config.credentials || 'same-origin',
        headers: config.headers || {}
      });
    }

    sendBatch(batch, flushOptions, retryDelays) {
      var batchOptions = Object.assign({}, batch[0]?.options || {}, flushOptions || {}, {
        skipQueueFlush: true
      });
      batchOptions.keepalive = batchOptions.keepalive === true || batch.some(function(entry) {
        return entry.options?.keepalive === true;
      });
      batchOptions.useBeacon = batchOptions.useBeacon === true || batch.some(function(entry) {
        return entry.options?.useBeacon === true;
      });
      var actions = batch.map(function(entry) {
        return entry.action;
      });

      if (getBodySize(getReportBody(actions)) > this.maxBytes && actions.length === 1) {
        console.warn('Queued action exceeds the configured batch size:', actions[0]);
      }

      return reportActions(actions, batchOptions)
        .then(function(result) {
          batch.forEach(function(entry) {
            entry.resolve(result);
          });
          return result;
        })
        .catch((error) => {
          if (retryDelays.length) {
            var delay = retryDelays.shift();
            return new Promise((resolve) => {
              window.setTimeout(resolve, delay);
            }).then(() => this.sendBatch(batch, flushOptions, retryDelays));
          }

          batch.forEach(function(entry) {
            entry.reject(error);
          });
          console.warn('Queued action batch failed:', error);
          return null;
        });
    }

    getQueuedBodySize() {
      return getBodySize(getReportBody(this.entries.map(function(entry) {
        return entry.action;
      })));
    }

    scheduleFlush() {
      if (this.flushTimer) return;

      this.flushTimer = window.setTimeout(() => {
        this.flushTimer = null;
        void this.flush('interval');
      }, this.flushInterval);
    }

    cancelScheduledFlush() {
      if (!this.flushTimer) return;
      window.clearTimeout(this.flushTimer);
      this.flushTimer = null;
    }

    handleVisibilityChange() {
      if (document.visibilityState === 'hidden') {
        void this.flush('visibilitychange');
      }
    }

    handlePageHide() {
      void this.flush('pagehide');
    }

    handleOnline() {
      void this.flush('online');
    }

    destroy() {
      this.cancelScheduledFlush();
      this.started = false;
      document.removeEventListener('visibilitychange', this.handleVisibilityChange);
      window.removeEventListener('pagehide', this.handlePageHide);
      window.removeEventListener('online', this.handleOnline);
    }
  }

  // Trigger after visibility stays at/above threshold for the required duration.
  function observe(target, action, options) {
    var elements = resolveElements(target);
    var config = options || {};
    var threshold = typeof config.threshold === 'number' ? config.threshold : DEFAULT_THRESHOLD;
    var exposureDuration = typeof config.duration === 'number' ? config.duration : DEFAULT_EXPOSURE_DURATION;
    var once = config.once === true;
    var reportedElements = new WeakSet();
    var visibleElements = new WeakSet();
    var exposureTimers = new WeakMap();

    if (!elements.length) {
      return {
        disconnect: function() {},
        unobserve: function() {}
      };
    }

    function clearExposureTimer(element) {
      var timer = exposureTimers.get(element);
      if (!timer) return;

      clearTimeout(timer);
      exposureTimers.delete(element);
    }

    // Track elements currently above the threshold and report only after they stay visible long enough.
    function handleVisibilityChange(element, visibleRatio, observer) {
      if (visibleRatio < threshold) {
        visibleElements.delete(element);
        clearExposureTimer(element);
        return;
      }

      if (visibleElements.has(element)) return;

      visibleElements.add(element);
      clearExposureTimer(element);
      exposureTimers.set(element, setTimeout(function() {
        exposureTimers.delete(element);
        if (!visibleElements.has(element)) return;
        handleExposure(element, observer);
      }, exposureDuration));
    }

    // Send the exposure report. once=true makes each element report at most once.
    function handleExposure(element, observer) {
      if (once && reportedElements.has(element)) return;

      reportedElements.add(element);

      buildExposureAction(action, element, config)
        .then(function(payload) {
          return enqueueAction(payload, config).then(function(result) {
            if (typeof config.onSuccess === 'function') {
              config.onSuccess(result, element, payload);
            }
          }).catch(function(error) {
            if (!once) {
              reportedElements.delete(element);
            }

            if (typeof config.onError === 'function') {
              config.onError(error, element, payload);
              return;
            }

            console.warn('Exposure report failed:', error);
          });
        })
        .catch(function(error) {
          if (!once) {
            reportedElements.delete(element);
          }

          if (typeof config.onError === 'function') {
            config.onError(error, element);
            return;
          }

          console.warn('Exposure action build failed:', error);
        });

      if (once) {
        observer.unobserve(element);
      }
    }

    // Prefer native IntersectionObserver for visible-area ratio detection.
    if ('IntersectionObserver' in window) {
      var observer = new IntersectionObserver(function(entries) {
        entries.forEach(function(entry) {
          handleVisibilityChange(entry.target, entry.isIntersecting ? entry.intersectionRatio : 0, observer);
        });
      }, {
        root: config.root || null,
        rootMargin: config.rootMargin || '0px',
        threshold: [threshold]
      });

      elements.forEach(function(element) {
        observer.observe(element);
      });

      return {
        disconnect: function() {
          elements.forEach(function(element) {
            visibleElements.delete(element);
            clearExposureTimer(element);
          });
          observer.disconnect();
        },
        unobserve: function(element) {
          visibleElements.delete(element);
          clearExposureTimer(element);
          observer.unobserve(element);
        }
      };
    }

    var fallbackTimer = null;

    // Fallback for older browsers: compute the element/viewport intersection ratio manually.
    function getVisibleRatio(element) {
      var rect = element.getBoundingClientRect();
      var width = rect.width || rect.right - rect.left;
      var height = rect.height || rect.bottom - rect.top;
      var area = width * height;

      if (!area) return 0;

      var visibleWidth = Math.max(0, Math.min(rect.right, window.innerWidth) - Math.max(rect.left, 0));
      var visibleHeight = Math.max(0, Math.min(rect.bottom, window.innerHeight) - Math.max(rect.top, 0));

      return visibleWidth * visibleHeight / area;
    }

    function checkFallback() {
      elements.slice().forEach(function(element) {
        handleVisibilityChange(element, getVisibleRatio(element), fallbackObserver);
      });
    }

    function scheduleFallbackCheck() {
      if (fallbackTimer) return;

      fallbackTimer = setTimeout(function() {
        fallbackTimer = null;
        checkFallback();
      }, 100);
    }

    var fallbackObserver = {
      disconnect: function() {
        window.removeEventListener('scroll', scheduleFallbackCheck, true);
        window.removeEventListener('resize', scheduleFallbackCheck);
        clearTimeout(fallbackTimer);
        elements.forEach(clearExposureTimer);
      },
      unobserve: function(element) {
        visibleElements.delete(element);
        clearExposureTimer(element);

        var index = elements.indexOf(element);
        if (index !== -1) {
          elements.splice(index, 1);
        }

        if (!elements.length) {
          this.disconnect();
        }
      }
    };

    window.addEventListener('scroll', scheduleFallbackCheck, true);
    window.addEventListener('resize', scheduleFallbackCheck);
    checkFallback();

    return fallbackObserver;
  }

  class ExposeElement extends HTMLElement {
    constructor() {
      super();
      this.handleClick = this.handleClick.bind(this);
    }

    // Start exposure monitoring and click reporting when the element enters the DOM.
    connectedCallback() {
      this.setupExposureVisibility();
      this.syncExposureObserver();

      if (!this.hasAttribute('data-manual-report') && !this.clickListenerAttached) {
        this.addEventListener('click', this.handleClick, true);
        this.clickListenerAttached = true;
      }
    }

    // Release observers/listeners when the element is removed.
    disconnectedCallback() {
      if (this.clickListenerAttached) {
        this.removeEventListener('click', this.handleClick, true);
        this.clickListenerAttached = false;
      }

      this.disconnectExposureObserver();
      this.teardownExposureVisibility();
    }

    // Click reporting reuses the same payload builder and overrides action_type.
    handleClick(event) {
      if (!this.isExposureActive() || this.shouldSkipInputClick(event)) return;

      persistClickDomain(this);

      var options = Object.assign({}, this.buildOptions(), {
        keepalive: true
      });

      setTimeout(() => {
        buildExposureAction(this.buildAction(this, {
          action_type: this.dataset.exposeActionType || 'click'
        }), this, options)
          .then(function(payload) {
            return enqueueAction(payload, options);
          })
          .catch(function(error) {
            console.warn('Click report failed:', error);
          });
      }, 0);
    }

    setupExposureVisibility() {
      var visibilitySelector = this.dataset.exposeVisibilitySelector;
      if (!visibilitySelector || this.exposeVisibilityRoots) return;

      try {
        this.exposeVisibilityRoots = [];
        var ancestor = this.parentElement;

        while (ancestor) {
          if (ancestor.matches(visibilitySelector)) {
            this.exposeVisibilityRoots.push(ancestor);
          }
          ancestor = ancestor.parentElement;
        }
      }
      catch (error) {
        this.exposeVisibilityRoots = [];
        console.warn('Invalid exposure visibility selector:', visibilitySelector);
      }

      if (this.exposeVisibilityRoots.length && !this.exposeVisibilityObserver) {
        this.exposeVisibilityObserver = new MutationObserver(this.syncExposureObserver.bind(this));
        this.exposeVisibilityRoots.forEach((root) => {
          this.exposeVisibilityObserver.observe(root, {
            attributes: true,
            attributeFilter: ['aria-hidden', 'hidden', 'inert', 'open']
          });
        });
      }
    }

    teardownExposureVisibility() {
      this.exposeVisibilityObserver?.disconnect();
      this.exposeVisibilityObserver = null;
      this.exposeVisibilityRoots = null;
    }

    isExposureActive() {
      return (this.exposeVisibilityRoots || []).every((root) => {
        if (root.hidden || root.hasAttribute('inert') || root.getAttribute('aria-hidden') === 'true') {
          return false;
        }

        return root.localName !== 'details' || root.hasAttribute('open');
      });
    }

    syncExposureObserver() {
      if (!this.isExposureActive()) {
        this.disconnectExposureObserver();
        return;
      }

      if (!this.exposeObserver) {
        var exposureTarget = this.getExposureTarget();
        this.exposeObserver = observe(exposureTarget, function() {
          return this.buildAction(this);
        }.bind(this), this.buildOptions());
      }
    }

    // Boxless wrappers (including display: contents) expose their rendered child instead.
    getExposureTarget() {
      var hasLayoutBox = window.getComputedStyle(this).display !== 'contents'
        && Array.prototype.some.call(this.getClientRects(), function(rect) {
          return rect.width > 0 && rect.height > 0;
        });
      return hasLayoutBox ? this : (this.firstElementChild || this);
    }

    disconnectExposureObserver() {
      if (!this.exposeObserver) return;

      this.exposeObserver.disconnect();
      this.exposeObserver = null;
    }

    shouldSkipInputClick(event) {
      var target = event && event.target;
      if (target && target.closest && target.closest('[data-skip-parent-expose-click]')) return true;

      if (!this.hasAttribute('data-dedupe-input-click')) return false;

      var isInputClick = target && target.matches && target.matches('input[type="radio"], input[type="checkbox"]');

      if (isInputClick && this.lastLabelClickAt && Date.now() - this.lastLabelClickAt < 300) {
        this.lastLabelClickAt = 0;
        return true;
      }

      if (target && target.closest && target.closest('label')) {
        this.lastLabelClickAt = Date.now();
      }

      return false;
    }

    // Supports data-threshold/data-duration/data-once/data-endpoint for the current element.
    buildOptions() {
      var options = {};
      var threshold = Number(this.dataset.threshold);
      var duration = Number(this.dataset.duration);

      if (!Number.isNaN(threshold) && threshold > 0) {
        options.threshold = threshold;
      }

      if (!Number.isNaN(duration) && duration >= 0) {
        options.duration = duration;
      }

      if (this.hasAttribute('data-once')) {
        options.once = true;
      }

      if (this.dataset.endpoint) {
        options.endpoint = this.dataset.endpoint;
      }

      return options;
    }

    // Build business fields from data-* attributes; data-exinfo1 can override exinfo1.
    buildAction(element, overrides) {
      const clickType = element.dataset?.clickType || '';
      var exinfo = {
        source: getUrlSource(),
        url: window.location.href
      };

      if (clickType == 'check') {
        const checkbox = element.querySelector('input[type="checkbox"]');
        const ischecked = checkbox ? checkbox.checked : element.classList.contains('checked');
        const quantity = element.querySelector('.quantity-input')?.value;
        exinfo.checked = ischecked;
        quantity ? exinfo.quantity = quantity : '';
      }

      return Object.assign({
        item_id: element.dataset.exposeItemId || element.dataset.productId,
        domain: element.dataset.domain,
        exinfo1: element.dataset.exinfo1 || JSON.stringify(exinfo)
      }, overrides || {});
    }
  }

  class ExposeViewElement extends ExposeElement {
    // Exposure-only element: optionally follow an ancestor's active/inactive state.
    connectedCallback() {
      this.setupExposureVisibility();
      this.syncExposureObserver();
    }

    disconnectedCallback() {
      this.disconnectExposureObserver();
      this.teardownExposureVisibility();
    }
  }

  class ExposeContainer extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;

      this.initialized = true;
      this.abortController = new AbortController();
      this.exposureObservers = [];
      this.trackedElements = new WeakSet();
      this.clickableSelector = 'a[href], summary';

      this.querySelectorAll(this.clickableSelector).forEach((element) => {
        var itemId = element.dataset.exposeItemId || this.getLinkItemId(element);
        if (!itemId) return;

        element.dataset.exposeItemId = itemId;
        element.dataset.domain = this.dataset.domain || '';
        element.dataset.exposeActionType = element.dataset.exposeActionType || 'click';
        this.trackedElements.add(element);
        this.exposureObservers.push(observe(
          element,
          function() {
            return ExposeElement.prototype.buildAction(element);
          }
        ));
      });

      this.addEventListener('click', this.handleClick, {
        capture: true,
        signal: this.abortController.signal
      });
    }

    disconnectedCallback() {
      this.abortController?.abort();
      this.exposureObservers?.forEach(function(observer) {
        observer.disconnect();
      });
      this.exposureObservers = [];
      this.trackedElements = null;
      this.initialized = false;
    }

    handleClick = (event) => {
      var element = event.target?.closest?.(this.clickableSelector);
      if (!element || !this.contains(element) || !this.trackedElements?.has(element)) return;

      persistClickDomain(element);
      var options = { keepalive: true };
      var action = ExposeElement.prototype.buildAction(element, {
        action_type: element.dataset.exposeActionType || 'click'
      });

      buildExposureAction(action, element, options)
        .then(function(payload) {
          return enqueueAction(payload, options);
        })
        .catch(function(error) {
          console.warn('Container click report failed:', error);
        });
    };

    getLinkItemId(element) {
      if (!element.matches('a[href]')) return '';

      var prefix = this.dataset.exposeItemPrefix || 'link';
      return prefix + '_link_' + element.getAttribute('href');
    }
  }

  class ExposePageView {
    constructor(options) {
      this.options = options || {};
      this.handleScroll = this.handleScroll.bind(this);
      this.handleVisibilityChange = this.handleVisibilityChange.bind(this);
      this.handlePageHide = this.handlePageHide.bind(this);
      this.handlePageShow = this.handlePageShow.bind(this);
      this.handleFreeze = this.handleFreeze.bind(this);
      this.handleBeforeUnload = this.handleBeforeUnload.bind(this);
      this.handleNavigate = this.handleNavigate.bind(this);
      this.handlePopState = this.handlePopState.bind(this);
      this.handleDocumentClick = this.handleDocumentClick.bind(this);
    }

    start() {
      if (this.started) return this;

      this.started = true;
      this.resetSession();
      window.addEventListener('scroll', this.handleScroll, { passive: true });
      window.addEventListener('resize', this.handleScroll, { passive: true });
      window.addEventListener('pagehide', this.handlePageHide);
      window.addEventListener('pageshow', this.handlePageShow);
      window.addEventListener('beforeunload', this.handleBeforeUnload);
      document.addEventListener('visibilitychange', this.handleVisibilityChange);
      document.addEventListener('freeze', this.handleFreeze);
      document.addEventListener('click', this.handleDocumentClick);
      window.navigation?.addEventListener('navigate', this.handleNavigate);
      window.addEventListener('popstate', this.handlePopState);
      return this;
    }

    stop(options) {
      if (!this.started) return Promise.resolve(null);

      var config = options || {};
      this.pauseVisibleDuration();
      this.started = false;
      window.removeEventListener('scroll', this.handleScroll);
      window.removeEventListener('resize', this.handleScroll);
      window.removeEventListener('pagehide', this.handlePageHide);
      window.removeEventListener('pageshow', this.handlePageShow);
      window.removeEventListener('beforeunload', this.handleBeforeUnload);
      document.removeEventListener('visibilitychange', this.handleVisibilityChange);
      document.removeEventListener('freeze', this.handleFreeze);
      document.removeEventListener('click', this.handleDocumentClick);
      window.navigation?.removeEventListener('navigate', this.handleNavigate);
      window.removeEventListener('popstate', this.handlePopState);

      if (this.animationFrame) {
        window.cancelAnimationFrame(this.animationFrame);
        this.animationFrame = null;
      }

      return config.report === true ? this.report() : Promise.resolve(this.getSnapshot());
    }

    resetSession() {
      this.sessionId = (this.sessionId || 0) + 1;
      var sessionId = this.sessionId;
      this.url = this.options.url || window.location.href;
      this.maxDepth = 0;
      this.visibleDuration = 0;
      this.visibleStartedAt = document.visibilityState === 'visible' ? this.now() : null;
      this.reported = false;
      this.preparedPayload = null;
      this.updateDepth();
      this.payloadPromise = buildExposureAction(
        this.getSnapshot(),
        null,
        this.options
      ).then((payload) => {
        if (this.sessionId === sessionId) {
          this.preparedPayload = payload;
        }
        return payload;
      }).catch(function(error) {
        console.warn('Page view payload preparation failed:', error);
        return null;
      });
    }

    now() {
      return window.performance && typeof window.performance.now === 'function'
        ? window.performance.now()
        : Date.now();
    }

    handleScroll() {
      if (this.animationFrame) return;

      this.animationFrame = window.requestAnimationFrame(() => {
        this.animationFrame = null;
        this.updateDepth();
      });
    }

    updateDepth() {
      var documentElement = document.documentElement;
      var body = document.body;
      var viewportHeight = window.innerHeight || documentElement.clientHeight || 0;
      var documentHeight = Math.max(
        documentElement.scrollHeight,
        documentElement.offsetHeight,
        documentElement.clientHeight,
        body?.scrollHeight || 0,
        body?.offsetHeight || 0
      );
      var scrollTop = window.scrollY || window.pageYOffset || documentElement.scrollTop || 0;
      var depth = documentHeight <= viewportHeight
        ? 1
        : (scrollTop + viewportHeight) / documentHeight;

      if (scrollTop + viewportHeight >= documentHeight - 1) {
        depth = 1;
      }

      depth = Math.min(1, Math.max(0, depth));
      this.maxDepth = Math.max(this.maxDepth, Math.round(depth * 10000) / 10000);
      return this.maxDepth;
    }

    pauseVisibleDuration() {
      if (this.visibleStartedAt === null) return;

      this.visibleDuration += Math.max(0, this.now() - this.visibleStartedAt);
      this.visibleStartedAt = null;
    }

    resumeVisibleDuration() {
      if (this.reported || this.visibleStartedAt !== null) return;
      this.visibleStartedAt = this.now();
    }

    getVisibleDuration() {
      var activeDuration = this.visibleStartedAt === null
        ? 0
        : Math.max(0, this.now() - this.visibleStartedAt);
      return Math.max(0, Math.round(this.visibleDuration + activeDuration));
    }

    getSnapshot() {
      this.updateDepth();
      return {
        action_type: 'view',
        item_id: '',
        url: this.url,
        depth: this.maxDepth,
        duration_ms: this.getVisibleDuration(),
        domain: this.options.domain,
        exinfo1: JSON.stringify({
          source: getUrlSource(),
          url: this.url
        })
      };
    }

    report(reportOptions) {
      if (this.reported) return Promise.resolve(null);

      this.pauseVisibleDuration();
      this.reported = true;
      var options = Object.assign({}, this.options, reportOptions || {}, { keepalive: true });
      var snapshot = this.getSnapshot();

      if (this.preparedPayload) {
        return this.sendPayload(this.mergeSnapshot(this.preparedPayload, snapshot), options);
      }

      return this.payloadPromise
        .then(function(preparedPayload) {
          if (!preparedPayload) {
            return buildExposureAction(snapshot, null, options);
          }

          return this.mergeSnapshot(preparedPayload, snapshot);
        }.bind(this))
        .then((payload) => {
          return this.sendPayload(payload, options);
        })
        .catch(function(error) {
          console.warn('Page view report failed:', error);
          return null;
        });
    }

    mergeSnapshot(preparedPayload, snapshot) {
      return Object.assign({}, preparedPayload, {
        item_id: '',
        url: snapshot.url,
        depth: snapshot.depth,
        duration_ms: snapshot.duration_ms,
        exinfo1: snapshot.exinfo1
      });
    }

    sendPayload(payload, options) {
      // console.log('[Expose] Page view:', payload);
      return reportAction(payload, options).catch(function(error) {
        console.warn('Page view report failed:', error);
        return null;
      });
    }

    handleVisibilityChange() {
      if (document.visibilityState === 'hidden') {
        this.pauseVisibleDuration();
        void this.report({ useBeacon: true });
        return;
      }

      if (this.reported) {
        this.resetSession();
        return;
      }

      this.resumeVisibleDuration();
    }

    handlePageHide() {
      this.pauseVisibleDuration();
      void this.report({ useBeacon: true });
    }

    handleFreeze() {
      this.pauseVisibleDuration();
      void this.report({ useBeacon: true });
    }

    handleBeforeUnload() {
      this.pauseVisibleDuration();
      void this.report({ useBeacon: true });
    }

    handleNavigate(event) {
      if (!['traverse', 'reload'].includes(event.navigationType)) return;

      this.pauseVisibleDuration();
      void this.report({ useBeacon: true });
    }

    handlePopState() {
      if (window.location.href === this.url) return;

      this.pauseVisibleDuration();
      void this.report({ useBeacon: true });
      this.resetSession();
    }

    handleDocumentClick(event) {
      if (
        event.defaultPrevented ||
        (typeof event.button === 'number' && event.button !== 0) ||
        event.metaKey ||
        event.ctrlKey ||
        event.shiftKey ||
        event.altKey
      ) return;

      var link = event.target?.closest?.('a[href]');
      if (!link || link.hasAttribute('download')) return;

      var target = normalizeValue(link.getAttribute('target'));
      if (target && target !== '_self') return;

      try {
        var destination = new URL(link.href, window.location.href);
        var current = new URL(window.location.href);
        var isSameDocumentAnchor = destination.pathname === current.pathname &&
          destination.search === current.search &&
          destination.hash;

        if (
          destination.origin !== current.origin ||
          !['http:', 'https:'].includes(destination.protocol) ||
          isSameDocumentAnchor
        ) return;

        void this.report();
      }
      catch (error) {
        // Ignore malformed href values and let the browser handle the click.
      }
    }

    handlePageShow(event) {
      if (!event.persisted) return;
      this.resetSession();
    }
  }

  window.Expose = window.Expose || {};
  window.Expose.listen = observe;
  window.Expose.observe = observe;
  window.Expose.reportAction = reportAction;
  window.Expose.reportActions = reportActions;
  window.Expose.enqueueAction = enqueueAction;
  window.Expose.flushActions = function(reason) {
    return eventQueue.flush(reason || 'manual');
  };
  window.Expose.buildExposureAction = buildExposureAction;
  window.Expose.getUserId = getUserId;
  window.Expose.getAttributionDomain = getAttributionDomain;
  window.Expose.persistClickDomain = persistClickDomain;
  window.Expose.Element = ExposeElement;
  window.Expose.ViewElement = ExposeViewElement;
  window.Expose.PageView = ExposePageView;
  window.Expose.EventQueue = ExposeEventQueue;

  eventQueue = window.Expose.eventQueue || new ExposeEventQueue();
  window.Expose.eventQueue = eventQueue;

  if (!customElements.get('expose-element')) {
    customElements.define('expose-element', ExposeElement);
  }

  if (!customElements.get('expose-view-element')) {
    customElements.define('expose-view-element', ExposeViewElement);
  }

  if (!customElements.get('expose-container')) {
    customElements.define('expose-container', ExposeContainer);
  }

  syncProductLinkSources(document);
  document.addEventListener('DOMContentLoaded', function() {
    syncProductLinkSources(document);
  }, { once: true });
  document.addEventListener('shopify:section:load', function(event) {
    syncProductLinkSources(event.target);
  });

  syncAttributionDomainFromUrl();

  if (!window.Expose.pageView) {
    window.Expose.pageView = new ExposePageView();
    window.Expose.pageView.start();
  }

  eventQueue.start();
})();
